import { createSelector } from 'reselect';
import { columns } from '../../constants/data';
import { filter, mapTagsLocationName } from '../transform';
import getPopulatedTags from './getPopulatedTags';

const getFilters = state => state.tags.filters;

/**
  @name getFilteredTags
  Selector to obtain the filtered list of tags
*/
const getFilteredTags = createSelector(
  [getPopulatedTags, getFilters],
  (tags, filters) => mapTagsLocationName(filter(tags, filters, columns))
);

export default getFilteredTags;



// WEBPACK FOOTER //
// ./src/utils/selectors/getFilteredTags.js